import React, { useContext } from "react";
import { Grid, CardActionArea, Button } from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";
import DottedTile from "../common/DottedTile";
import { grey } from "@mui/material/colors";
import Check from "../../auth/ability";
import { CAN, SUBJECTS } from "../../auth/permissions";
import { ACTIONS, WizardContext } from "../wizard/Context";
import { MODULES } from "../../services/Constants";
import useModule from "../../hooks/useModule";

const CreateConfigurationTile = () => {
  const { dispatch } = useContext(WizardContext);
  const { validateModuleWithMessage } = useModule();
  return (
    <Check I={CAN.CREATE} a={SUBJECTS.CONFIGURATION}>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }} >
        <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2 }} >
          <CardActionArea
            onClick={() => {
              if (validateModuleWithMessage(MODULES.CONFIGURATION)) {
                dispatch({
                  type: ACTIONS.SHOW_CONFIG_WIZARD,
                });
              }
            }}
          >
            <Button
              variant="contained"
              startIcon={<TuneIcon />}
              sx={{ width: "100%", borderRadius: '6px' }}
            >
              CREATE A CONFIGURATION
            </Button>
          </CardActionArea>
        </Grid>
      </Grid>
    </Check>
  );
};

export default CreateConfigurationTile;
